import { useParams } from 'react-router-dom';
import { WebsiteRenderer } from '@agency/website-renderer';
import { useAgencyData } from '../data.js';

export function PublicSitePage() {
  const { slug } = useParams(); const {getProspect,loading}=useAgencyData(); const prospect=getProspect(slug);
  if (loading) return <main className="empty-state"><h1>Loading website…</h1></main>;
  if (!prospect) return <main className="empty-state"><h1>Website not found</h1></main>;
  if (prospect.importedSite) return <iframe className="public-imported-site" src={prospect.importedSite.url} title={`${prospect.businessName} website`} sandbox="allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts" />;
  return <WebsiteRenderer config={prospect.websiteConfig} />;
}
